import { noop, slice } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Address from '../../../../1stlog-ui/src/components/Address'
import Button from '../../../../1stlog-ui/src/components/Button'
import Input from '../../../../1stlog-ui/src/components/Input'
import TypeAhead from '../../../../1stlog-ui/src/components/TypeAhead'
import { request } from '../../../../1stlog-ui/src/utils'
import useOrderEntry from '../../OrderEntry/useOrderEntry'

const Wrapper = styled.div``

const NameSearch = (props) => {
  const { onOpenAddressBook = noop, withoutAddressbook, onApply = noop } = props

  const { tenantId, addressbookUrl } = useOrderEntry()

  const renderOption = (suggestion, matcher) => {
    const { query } = matcher
    // console.log("su", { suggestion, matcher })
    return (
      <div>
        <Address biggerNames {...suggestion} name1ToHighlight={query} />
      </div>
    )
    // return (
    //   <div style={{}}>
    //     <Address biggerNames {...option} name1ToHighlight={props.text} />
    //   </div>
    // )
  }

  const requestOptions = async (searchBy = 'description', value) => {
    // console.log("requestOptions", { searchBy, value, tenantId, addressbookUrl })
    try {
      let { data } = await request({
        method: 'post',
        url: `${addressbookUrl}/autocomplete`,
        data: {
          name1: value,
          customerId: tenantId,
        },
      })
      return slice(data, 0, 5)
    } catch (error) {
      console.error(error)
      return []
    }
  }

  const onSuggestionSelected = (
    e,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method },
  ) => {
    // console.log('onSuggestionSelected', suggestion)
    onApply(suggestion)
  }

  return (
    <Wrapper className="d-flex">
      <div className="flex-fill">
        {withoutAddressbook ? (
          <Input {...props} />
        ) : (
          <TypeAhead
            {...props}
            renderOption={renderOption}
            requestOptions={requestOptions}
            onSuggestionSelected={onSuggestionSelected}
          />
        )}
      </div>
      {!withoutAddressbook && (
        <div className="ml-2">
          <Button
            onClick={onOpenAddressBook}
            light
            icon="fas fa-address-book"
            tooltip={i18n.t(`search_address_in_addressBook`, `Adresse in Adressbuch suchen`)}
          />
        </div>
      )}
    </Wrapper>
  )
}

export default NameSearch
